import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 8l2 8l2 -8","key":"svg-1"}]]

const IconCircleLetterV = createReactComponent('outline', 'circle-letter-v', 'CircleLetterV', __iconNode);

export default IconCircleLetterV;